module.exports = __webpack_public_path__ + "h5/img/cs_22.41bbe6f7.jpg";